<template>

  
<Toast position="bottom-right" />
<!-- <Loading :active="isLoading"></Loading>  -->
  <Header></Header>
   <div :class="{'container my-3': ($route.path!=='/home' && $route.path!=='/' && $route.path!=='/index.html') }" >
    <router-view />
  </div>
  
 <br/>
 <br/>
 <br/>
 <!-- <a :href="boturl" target="_blank"> -->
 <img src="images/abaoicon.png" 
 class="abao" 
 style="cursor:pointer"  
 id="abaoicon"   
 v-on:dblclick="gotoURL()"
 @mouseover="handleMouseOver"
 @mouseout="handleMouseOut"
 role="button" tabindex="0" aria-grabbed="false">
<!-- </a> -->


<VIPFooter></VIPFooter>




<div v-if="isLoading">
  <Loading v-model:active="isLoading"
                 :can-cancel="true"
                 :on-cancel="onCancel"
                 :is-full-page="fullPage"/> 

</div>

<!--Edit Modal -->
<Dialog
    v-model:visible="isShowDialog"
    :style="{ width: '950px'}"
    header="Terms and Conditions"
    :modal="true"
    :closable="false"
    class="p-fluid"
  >
    <component
      :is="'Modal_Declaration'"
      @hide="hide"
      @show="show"
      @after-hide="afterhide"
      @agree="modalAgree"
      @close="modalClose"
    ></component>
  </Dialog>
<!-- 
  <a id="totop" :href="boturl" target="_blank">
      <img src="images/owl_zh-TW.png" style="cursor:pointer ;width: 200px;height: 200px; left: -50;top:-100">
  </a> -->

</template>
 
<script>
// import ApplyPage from './components/ApplyPage.vue'
import Header from './components/Header.vue'
import VIPFooter from './components/VIPFooter.vue'
import Service from "./service/service";
import CommonService from "./service/CommonService";
import FlowService from "./service/FlowService";
import { getCurrentInstance } from 'vue'
 

// import variables from "@/service/variables";
export default {
  name: 'App',
  components: {
    // ApplyPage,
    Header,
  
    VIPFooter
 
  },
  Service: null,
  CommonService:null,
  FlowService: null,
  data() {
    return {
      boturl:null,
      isShowDialog:false,
      fullPage: true,
      username: "bob",
        message: "",
        timer: null,
      connectionstatus: "init",
       proxy : getCurrentInstance(),
    }
  },
  provide() {
          return {
            GetFlowNeedToApprovalCount: this.GetFlowNeedToApprovalCount,
          };
        },
  created() {
    let self=this;
    this.proxy=getCurrentInstance();
  /*   console.log('111111111111111111111')
    console.log(this.$signalr)
    console.log(this.proxy.$signalr)
    console.log(getCurrentInstance())
    console.log('22222222222222222222') */

    //console.log('process.env.VUE_APP_BOTURL') 
    //console.log(process.env.VUE_APP_BOTURL) 

    this.Service = new Service();
    this.CommonService = new CommonService();
    this.FlowService = new FlowService();
    if(this.user)
    {


      this.boturl=process.env.VUE_APP_BOTURL+this.cookie_token;

            if(this.$store.state.user?.Culture){
              this.setLang(this.$store.state.user?.Culture);
            }

        if(!this.isDeclaration)
        {
          this.isShowDialog=true;
        } 
        else 
        {
          this.isShowDialog=false;
          if(self.user?.IsActive==false && self.is_Supervisor==true)
          {
            setTimeout(() => {
              self.$router.replace("/supervisorUpdateInformation");
            }, 50); 
          }
          else if(self.is_CompalUser==true)
          {
            setTimeout(() => {
              self.GetFlowNeedToApprovalCount();
            }, 50); 
          
          }
        } 
    
    }
     else {
      alert('請先登入');
       setTimeout(() => {
        this.$router.replace("/login");
      }, 50); 
      
    } 
    
  },
  mounted(){
      this.initABAO();
       /*  if('development'==this.CommonService.GetHeaderTitle())
        {
            this.boturl="https://tpeqascrawler.compal.com/it-bot/vip?t="+this.cookie_token;
         }
        else if('test'==this.CommonService.GetHeaderTitle())
        {
          this.boturl="https://tpeqascrawler.compal.com/it-bot/vip?t="+this.cookie_token;
        }
        else
        {
          this.boturl="https://tpeqascrawler.compal.com/it-bot/vip?t="+this.cookie_token;
        } */
        
  
  this.$signalr.start().then(() => {
  if (window.Notification) {
    if (Notification.permission === 'granted') {
      console.log('允许通知')
    } else if (Notification.permission !== 'denied') {
      console.log('需要通知权限')
      Notification.requestPermission((permission) => { console.log("权限通知",permission) })
    } else if (Notification.permission === 'denied') {
      console.log('拒绝通知')
    }
  } else {
    console.error('浏览器不支持Notification')
  }
  console.log('连接成功')
})

   


  },
  computed: {
    isLoading() {
      return this.$store.state.isLoading;
     },
     
     routerName(){
      return this.$router.currentRoute;
     },
    user() {
     return this.$store.state.user;
    },
    user_account() {
     return this.$store.state.user?.account;
    },
    user_Id() {
     return this.$store.state.user?.id;
    },
    user_userName() {
     return this.$store.state.user?.userName;
    },
    user_bg() {
     return this.$store.state.user?.bg;
    },
    user_buyerMapping() {
     return this.$store.state.user?.buyerMapping;
    },
    user_sourcerMapping() {
     return this.$store.state.user?.sourcerMapping;
    },
    user_vendorMapping() {
     return this.$store.state.user?.vendorMapping;
    },
    user_mfgcode() {
     return this.$store.state.user?.mfgcode;
    },
    user_mfgsearchterm() {
     return this.$store.state.user?.mfgsearchterm;
    },
    user_roles() {
     return this.$store.state.user?.Roles;
    },
    clientId() {
     return this.$store.state.user?.clientId;
    },

    isActive() {
     return this.$store.state.user?.IsActive;
    },
    culture() {
     return this.$store.state.user?.Culture;
    },
    
    is_VIPAdmin(){
       return this.user_roles && this.user_roles.includes('VIPAdmin');
    },
    is_SCSI(){
       return this.user_roles && this.user_roles.includes('SCSI');
    },
    is_Sourcer(){
       return this.user_roles && this.user_roles.includes('Sourcer');
    },
    is_Buyer(){
       return this.user_roles && this.user_roles.includes('Buyer');
    },
    is_CompalUser(){
       return this.user_roles && this.user_roles.includes('CompalUser');
    },
    is_VendorUser(){
       return this.user_roles && this.user_roles.includes('VendorUser');
    },
    is_Supervisor(){
       return this.user_roles && this.user_roles.includes('Supervisor');
    },
    token() {
     return this.$store.state.token;
    },
    refreshToken() {
     return this.$store.state.refreshToken;
    },
    sessionCode() {
     return this.$store.state.sessionCode;
    },
    isDeclaration() {
     return this.$store.state.isDeclaration;
    },
    flowCount() {
      return this.$store.state.flowcount;
    },

    cookie_token() {
     return this.$cookies.get("vip_token");
    },
    cookie_refreshToken() {
     return this.$cookies.get("vip_refreshToken");
    },
    cookie_sessionCode() {
     return this.$cookies.get("vip_sessionCode");
    },
     startrouter() {
      return this.$store.state.startrouter;
    },
 

  },
   
  methods: {


    handleMouseOver(e)  {
      console.log(e)
      //e.target.getStage().container().style.cursor = 'pointer';
    },

 handleMouseOut(e)  {
    console.log(e)
  ///e.target.getStage().container().style.cursor = 'default';
},
    gotoURL(){
      console.log('gotoURL')
        window.open(this.boturl);

    },

   initABAO(){


    const icon = document.getElementById("abaoicon");

    icon.style.cursor = "pointer";

     let dragging = false,
         startX = 0,
         startY = 0,
         startLeft = 0,
         startTop = 0;

     const clamp = (v, a, b) => Math.max(a, Math.min(b, v));
     const rect = () => icon.getBoundingClientRect();

     icon.addEventListener("pointerdown", (e) => {
         e.preventDefault();
         icon.setPointerCapture(e.pointerId);
         dragging = true;
         icon.setAttribute("aria-grabbed", "true");
         startX = e.clientX;
         startY = e.clientY;
         const r = rect();
         startLeft = r.left;
         startTop = r.top;
     });

     window.addEventListener("pointermove", (e) => {
         if (!dragging) return;
         e.preventDefault();
         const r = rect();
         const dx = e.clientX - startX;
         const dy = e.clientY - startY;
         let nx = startLeft + dx;
         let ny = startTop + dy;
         nx = clamp(nx, 0, window.innerWidth - r.width);
         ny = clamp(ny, 0, window.innerHeight - r.height);
         icon.style.left = nx + "px";
         icon.style.top = ny + "px";
     });

     window.addEventListener("pointerup", (e) => {
         if (!dragging) return;
         dragging = false;
         try {
             icon.releasePointerCapture(e.pointerId);
         } catch (e) {
          console.log(e);
         }
         icon.setAttribute("aria-grabbed", "false");
     });

     // 鍵盤微調支援
     icon.addEventListener("keydown", (e) => {
         const step = e.shiftKey ? 20 : 8;
         const r = rect();
         let nx = r.left,
             ny = r.top;
         if (e.key === "ArrowLeft") nx -= step;
         else if (e.key === "ArrowRight") nx += step;
         else if (e.key === "ArrowUp") ny -= step;
         else if (e.key === "ArrowDown") ny += step;
         else return;
         e.preventDefault();
         nx = clamp(nx, 0, window.innerWidth - r.width);
         ny = clamp(ny, 0, window.innerHeight - r.height);
         icon.style.left = nx + "px";
         icon.style.top = ny + "px";
     });

     // 視窗縮放時維持在可見範圍
     window.addEventListener("resize", () => {
         const r = rect();
         const nx = clamp(r.left, 0, window.innerWidth - r.width);
         const ny = clamp(r.top, 0, window.innerHeight - r.height);
         icon.style.left = nx + "px";
         icon.style.top = ny + "px";
     });


   },



    hide(){
      console.log('hide')
    },
    show(){ console.log('show')},
    afterhide(){ console.log('afterhide')},

    modalAgree(){
      let self=this;
      this.isShowDialog=false;
      this.$store.commit("Set_Declaration", true);
      this.CommonService.Agree().then(() => {
        if(self.$store.state.user?.IsActive==false && self.is_Supervisor==true)
          {
            setTimeout(() => {
              self.$router.replace("/supervisorUpdateInformation");
            }, 50); 
          }
          else if(self.is_CompalUser==true)
          {
            setTimeout(() => {
              self.GetFlowNeedToApprovalCount();
            }, 50); 
           
          }
       })

          


    },
    modalClose(){
      let self=this;
      this.isShowDialog=false;

      this.CommonService.DisAgree().then(() => {

        self.$store.commit("Set_Declaration", false);

        self.$cookies.remove("vip_token");
        self.$cookies.remove("vip_refreshToken");
        self.$cookies.remove("vip_sessionCode");
        self.$cookies.remove("cps_token");
        self.$cookies.remove("cps_refreshToken");
        self.$cookies.remove("cps_sessionCode");
        self.$cookies.remove("rfq_token");
        self.$cookies.remove("rfq_refreshToken");
        self.$cookies.remove("rfq_sessionCode");


        self.$store.commit("Set_Token", null);
        self.$store.commit("Set_RefreshToken", null);
        self.$store.commit("Set_SessionCode", null);
        self.$store.commit("Set_User", null);

        

          setTimeout(() => {
            self.$router.replace("/logout");
          }, 50);

      })

      


    },


    setLang (value) {
         this.$i18n.locale = value;
        },
        GetFlowNeedToApprovalCount() {
          this.FlowService.GetFlowNeedToApprovalCount().then(data=>{
           // console.log(data)
    
            this.$store.commit("Set_FlowCount", data);
          })
        },
     
    
 
  }

}
</script>
<style scoped>
.load-loading {

/* //绝对位置 */
 position:absolute; 
    /* //让对象成为块级元素 */
     display:block; 
/* //背景灰色 */
  background-color:gray;
/* //最上层显示 */
  z-index:9999;
/* //背景透明度 * */
  opacity:0.5;

    border: 16px solid #f3f3f3;
    border-top: 16px solid #3498db;
    border-radius: 50%;
    width: 120px;
    height: 120px;
    animation: loadingSpin 2s linear infinite;
    margin-top: 45%;
    margin-left: 45%;
   
   


}
#pv_id_3_header {

    color: red!important;
}
.p-dialog-title{
  color: red!important;
}

#totop {
  position: fixed;
  bottom: 25%;
  right: 10%;
  display: block;
  z-index: 9999;
  background: transparent;
  border: 3px solid #3C3C3C;
  border-radius: 50%; 
  height: 50px;
  width: 50px;
  text-align: center;
}
#totop i {
  color: #3C3C3C;
  line-height: 43px;
  font-size: 33px;
}
#totop:hover {
  background: #3C3C3C;
}
#totop:hover i {
  color: #ffffff;
}
.abao{    
    position: fixed;
    right: 5px;
    bottom: 40px;   
    width: 150px;
    height: 168px;
    cursor: pointer;
    z-index: 9999;
}
</style>
 
 